/**
 * Builds a tenant-scoped storage path for file uploads.
 * All storage uploads must use this to ensure tenant isolation.
 *
 * @param tenantId - The tenant UUID (from useTenantGuard)
 * @param resourceType - e.g. "cases", "clinical-visits", "leads"
 * @param resourceId - The specific resource UUID
 * @param fileName - Original file name (will be sanitized)
 * @returns A path like "{tenantId}/{resourceType}/{resourceId}/{timestamp}_{sanitizedName}"
 */
export const buildTenantPath = (
  tenantId: string,
  resourceType: string,
  resourceId: string,
  fileName: string
): string => {
  const timestamp = Date.now();
  const sanitized = fileName.replace(/[^a-zA-Z0-9.-]/g, "_");
  return `${tenantId}/${resourceType}/${resourceId}/${timestamp}_${sanitized}`;
};
